import React, { useState } from 'react';
import { Drawer, Form, Button, Input, Card, Space } from 'antd';
import { EditOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import SurveyGroupSelect from 'components/SurveyGroupSelect';

import globalMessages from 'translations/messages';
import useCustomer from 'hooks/useCustomer';

import SegmentFiltersForm, { toFilterOptionsInput } from 'containers/Results/Filter/SegmentFiltersForm';
import messages from './messages';

const FunnelStepCard = ({ step, onRemove, onEdit }) => (
  <Card
    size="small"
    actions={[
      <Button type="text" block onClick={onEdit} icon={<EditOutlined />}>
        <FormattedMessage {...globalMessages.edit} />
      </Button>,
      <Button type="text" block danger onClick={onRemove} icon={<MinusCircleOutlined />}>
        <FormattedMessage {...globalMessages.delete} />
      </Button>,
    ]}
  >
    {step?.title}
  </Card>
);

const EditFunnelStep = ({ value, onChange, onRemove, sortIndex, websiteId }) => {
  const [editFunnelStep, setEditFunnelStep] = useState(false);
  const { customer } = useCustomer();
  const [form] = Form.useForm();

  const selectedSurvey = Form.useWatch('survey', form);

  const onClose = () => setEditFunnelStep(false);

  const onSubmit = ({ title, survey, filterOptions }) => {
    onChange({
      id: value?.id,
      title,
      sortIndex,
      surveyGroupId: survey.group.id,
      displayedSurveyId: survey.survey.id,
      filterOptions: toFilterOptionsInput([], filterOptions),
    });
    onClose();
  };

  return (
    <>
      <FunnelStepCard step={value} onRemove={onRemove} onEdit={() => setEditFunnelStep(true)} />
      <Drawer
        open={editFunnelStep}
        placement="right"
        onClose={onClose}
        width={400}
        title={<FormattedMessage {...messages.editFunnelStep} />}
        footer={(
          <Space>
            <Button
              onClick={onClose}
            >
              <FormattedMessage {...globalMessages.cancel} />
            </Button>
            <Button
              onClick={() => form.submit()}
              type="primary"
            >
              <FormattedMessage {...globalMessages.save} />
            </Button>
          </Space>
        )}
      >
        <Form form={form} className="segment-form" layout="vertical" initialValues={value} onFinish={onSubmit}>
          <Form.Item
            label={<FormattedMessage {...globalMessages.title} />}
            name="title"
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={<FormattedMessage {...globalMessages.survey} />}
            name="survey"
          >
            <SurveyGroupSelect
              customerId={customer?.id}
              websiteIds={websiteId ? [websiteId] : null}
              selectables={['survey']}
              valueAsObject
            />
          </Form.Item>
          <SegmentFiltersForm
            filterOptions={value?.filterOptions}
            isEditable
            customerId={customer?.id}
            surveyGroupId={selectedSurvey?.group.id}
            displayedSurveyId={selectedSurvey?.survey.id}
            formPath={['filterOptions']}
          />
        </Form>
      </Drawer>
    </>
  );
};

export default EditFunnelStep;
